import { apiMeGet } from '../api/me.[get]';
import { User, KioskDevice, Location, Company, Balance, LocationBalance } from '../XV2';
import { createStore } from '@orderx/lab/xr/store';
import { AppCache } from '../services/app-cache';
import { Api } from '@orderx/lab/xr/http';
import { Kiosk$ } from '../module/kiosk/Kiosk$';

const { useStore, reset } = createStore<{
    user: User;
    balances: UseMeUserBalance[];
    companies: Company[];
    locations: Location[];
    kioskDevice?: KioskDevice;
}>({
    user: undefined as any,
    balances: [],
    companies: [],
    locations: [],
});

export type UseMeUserBalance = Pick<
    Balance,
    'id' | 'name' | 'namePublic' | 'type' | 'amountInitial' | 'amountRemaining'
> & {
    locationBalances: (Pick<LocationBalance, 'locationId'> & {
        location: Pick<Location, 'id' | 'name' | 'currency'>;
    })[];
};

export function useMe() {
    const [state, setState] = useStore();
    const user = state?.user;

    return {
        userId: user?.id,
        user,
        locations: state.locations,
        companies: state.companies,
        isAuthenticated: Boolean(user),
        async loadUser() {
            const result = await apiMeGet({});

            if (result?.user) {
                setState(result);
                return result;
            }

            if (result?.kioskDevice) {
                Kiosk$.setDevice(result.kioskDevice);
            }

            return result;
        },
        getBalances(): UseMeUserBalance[] {
            return state.balances || [];
        },
        setToken(token: string) {
            AppCache.set('token', token);
            Api.setAuthorization(token);
        },
        signOut() {
            reset();
            AppCache.remove('token');
            Api.setAuthorization(undefined);
        },
    };
}
